export default "__VITE_ASSET__Dc$GxI4Y__"